export default __webpack_public_path__ + "static/media/flag16.188520e7.jpg";